import { IonButton, IonCol, IonIcon, IonText } from "@ionic/react";
import { heart, heartOutline } from "ionicons/icons";
import { useState } from "react";
import {
  makeDELETERequest,
  makePATCHRequest,
} from "../../../request/rawRequest";

interface ContainerProps {
  like: number;
  id: string;
  hasLike: boolean;
}

const Like: React.FC<ContainerProps> = ({ like, id, hasLike }) => {
  const [likes, setLikes] = useState<number>(like);
  const [isLiked, setIsLiked] = useState<boolean>(hasLike);

  function updateLikes(): void {
    if (isLiked === false) {
      setLikes(likes + 1);
      setIsLiked(true);
      makePATCHRequest("/feed/like?_id=" + id);
    } else {
      setLikes(likes - 1);
      setIsLiked(false);
      makeDELETERequest("/feed/like?_id=" + id);
    }
  }

  return (
    <IonCol className="ion-justify-content-center like">
      <IonButton
        onClick={(e) => updateLikes()}
        color="light"
        className="footer-btn like"
      >
        <IonIcon className="card-icon" icon={isLiked ? heart : heartOutline} />
      </IonButton>
      <IonText className="card-icon-text">{likes}</IonText>
    </IonCol>
  );
};

export default Like;
